/* eslint-disable camelcase */

type ErrorResponse = {
  message?: string;
  error?: {
    code?: string;
  } & {
    [key: string]: unknown;
  };
  two_factor_options?: unknown;
  two_factor_primary_method?: unknown;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

export default async function extractErrors(
  response: Response,
): Promise<Response> {
  const {status, statusText, headers} = response;
  const error = await extractFetchError(response);

  if (error) {
    const responseBody = {
      errors: [
        {
          ...error,
          httpStatus: status,
        },
      ],
    } as const;

    return new Response(JSON.stringify(responseBody), {
      status,
      statusText,
      headers,
    });
  } else {
    throw new Error('Unable to extract error from response');
  }
}

/**
 * Extracts error from Fetch response.
 * Returns null, when response is not a JSON error.
 */
async function extractFetchError(
  response: Response,
): Promise<ErrorResponse | null> {
  try {
    const json = await response.clone().json();
    const error = extractErrorFromResponseBody(json);
    if (error) {
      return error;
    }
  } catch {}

  return null;
}

function extractErrorFromResponseBody(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  responseBody: any,
): ErrorResponse | null | undefined {
  if (responseBody?.error || responseBody?.errors) {
    // HACK(aaron): The backend returns the information about what 2FA
    // methods a user has available whenever it returns a "Needs 2FA"
    // error. Auth-related services need access to this data, and
    // we can't change the way it works on the backend since the iOS
    // Dashboard is reliant on this data structure. So for now, just add
    // this data to the `error` object so services have access.
    if (responseBody?.two_factor_options) {
      responseBody.error.two_factor_options = responseBody.two_factor_options;
    }
    if (responseBody?.two_factor_primary_method) {
      responseBody.error.two_factor_primary_method =
        responseBody.two_factor_primary_method;
    }
    return responseBody.error || responseBody.errors[0];
  } else if (responseBody?.message) {
    return responseBody;
  } else {
    return null;
  }
}
